import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import RcButton from '@components/RcButton/RcButton.vue';
import { RcTagProps } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcTag',
  props: {
    type: {},
    disabled: { type: Boolean, default: false },
    showClose: { type: Boolean, default: false },
    closeAriaLabel: {},
    highlight: { type: Boolean, default: undefined }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rc-tag", {[props.type]: true, disabled: props.disabled, highlight: props.highlight}])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (props.showClose)
      ? (_openBlock(), _createBlock(RcButton, {
          key: 0,
          ghost: "",
          "aria-label": props.closeAriaLabel,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "icon icon-close" }, null, -1)
          ])),
          _: 1,
          __: [1]
        }, 8, ["aria-label"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})